"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SERVICE_EVENT_ATTACHMENTS = exports.MAX_VEHICLE_ATTACHMENTS = exports.MAX_ATTACHMENT_FILE_BYTES = exports.MAX_IMAGE_FILE_BYTES = void 0;
/** Kuvat (vehicle-image, business-image, jne.) — sama raja kuin palvelimella. */
exports.MAX_IMAGE_FILE_BYTES = 10 * 1024 * 1024;
/** Ajoneuvon liitteet (PDF/kuva) — sama yläraja kuin kuvilla */
exports.MAX_ATTACHMENT_FILE_BYTES = 10 * 1024 * 1024;
/** Liitteiden enimmäismäärä yhtä ajoneuvoa kohden — synkassa palvelimen S3-uploadin kanssa */
exports.MAX_VEHICLE_ATTACHMENTS = 3;
/** Liitteiden enimmäismäärä yhtä huoltotapahtumaa kohden — synkassa palvelimen S3-uploadin kanssa */
exports.MAX_SERVICE_EVENT_ATTACHMENTS = 3;
